import { createAction, props, ActionCreator } from '@ngrx/store';
import { capitalize } from 'lodash-es';
import { LoadError, LoadFilter } from './models';
import { StringTypedAction } from '../types';

export interface FilterChangedProps {
  filter: LoadFilter;
}

export interface LoadSucceededProps<Entity> {
  entities: Entity[];
}

export interface LoadErroredProps {
  error: LoadError | null;
}

export type LoadAction = ActionCreator<string, () => StringTypedAction>;

export type FilterChangedAction = ActionCreator<
  string,
  (props: FilterChangedProps) => FilterChangedProps & StringTypedAction
>;

export type LoadSucceededAction<Entity> = ActionCreator<
  string,
  (props: LoadSucceededProps<Entity>) => LoadSucceededProps<Entity> & StringTypedAction
>;
export type LoadErroredAction = ActionCreator<
  string,
  (props: LoadErroredProps) => LoadErroredProps & StringTypedAction
>;

export interface LoadActions<Entity> {
  load: LoadAction;
  loadSucceeded: LoadSucceededAction<Entity>;
  loadErrored: LoadErroredAction;
  filterChanged: FilterChangedAction;
}

export function createLoadActions<Entity>(type: string): LoadActions<Entity> {
  const Type = `[${capitalize(type)}]`;

  return {
    load: createAction(`${Type} Load`),
    loadSucceeded: createAction(`${Type} Load Succeeded`, props<LoadSucceededProps<Entity>>()),
    loadErrored: createAction(`${Type} Load Errored`, props<LoadErroredProps>()),
    filterChanged: createAction(`${Type} Filter Changed`, props<FilterChangedProps>()),
  };
}
